import { Button, CircularProgress, Menu, TextField, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Snackbar,

} from '@material-ui/core';
import CustomModal from './CustomModal';
import Layout from './Layout';
import moment from 'moment';


export const Payment = () => {

  const [orgID, setOrgId] = useState('');
  const [apiResponse, setApiResponse] = useState([]);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isInputEmpty, setIsInputEmpty] = useState(false);
  const [email, setEmail] = useState('');
  const [listPricing, setListPricing] = useState([]);
  const [phone, setPhone] = useState('');

  const [paymentData, setPaymentData] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('initiated');
  const [updatedPaymentData, setUpdatedPaymentData] = useState(null);
  const [individualPaymentStatuses, setIndividualPaymentStatuses] = useState({});

  const [pricingId, setPricingId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [deviceCounts, setDeviceCounts] = useState('');
  const [envCounts, setEnvCounts] = useState('');
  const [amount, setAmount] = useState('');
  const [newStatus, setNewStatus] = useState('Active');
  const [paymentStatusData, setPaymentStatusData] = useState({});
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [selectedPaymentToDelete, setSelectedPaymentToDelete] = useState(null);


  const [apiError, setApiError] = useState(null);

  const baseUrl = localStorage.getItem('environment') === "dev" || !localStorage.getItem('environment') ? "https://dev.phyfarm.com/" : "https://v3.api.phyfarm.com/";

  const handleOpen = () => {

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    setOpen(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const fetchPaymentData = (orgID, email, phone) => {

    setLoading(true); // Start loading

    let requestData = {};

    if (orgID) {
      requestData = { org_id: parseInt(orgID) };
    } else if (email) {
      requestData = { email: email };
    } else if (phone) {
      requestData = { phone: phone };
    } else {
      setIsInputEmpty(true);
      return;
    }

    const requestOptions = {

      method: 'POST',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    };

    fetch(baseUrl + 'api/mgmt/payments/listPaymetsCms', requestOptions)//https://dev.phyfarm.com/api/mgmt/payments/getOrgPaymentStatusCms
      .then((response) => response.json())
      .then((data) => {
        setLoading(false); // Stop loading
        if (data.error) {
          setError(data.error);
          setApiError(data.error);
          console.log(data);
        }
        console.log(data);
        setApiResponse(data.data.payments);
        setOpen(false);
      })
      .catch((error) => {
        setLoading(false); // Stop loading
        setError(error);
        setApiError('Error fetching payment data.');
      }
      );


    const paymentStatusRequestOptions = {

      method: 'POST',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        org_id: orgID ? parseInt(orgID) : null,
        email: email ? email : null,
        phone: phone ? phone : null,
      }),
    };

    fetch(baseUrl + 'api/mgmt/payments/getOrgPaymentStatusCms', paymentStatusRequestOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log('paymentStatusData', data);
        setPaymentStatusData(data); // Update paymentStatusData with the response data

      })
      .catch((error) => {
        console.error('Error fetching payment status data:', error);
      });
  };


  const handleOpenModal = (Payment) => {

    console.log(Payment);
    setSelectedPayment(Payment);
    setPricingId(Payment.pricing_id);
    setStartDate(Payment.start_date);
    setEndDate(Payment.end_date);
    setDeviceCounts(Payment.device_counts);
    setEnvCounts(Payment.env_counts);
    setSelectedStatus(Payment.transaction_status);
    setNewStatus(Payment.active ? 'Active' : 'Inactive');
    setAmount(Payment.amount);
    setModalOpen(true);
  };

  const handleClick = () => {

    if (!orgID && !email && !phone) {
      setIsInputEmpty(true);
      return;
    }

    setIsInputEmpty(false);
    fetchPaymentData(orgID, email, phone);
  };



  // Inside Payment component
  const handleOrgIdChange = (newOrgId) => {
    setOrgId(newOrgId);
    setIsInputEmpty(false);
  };

  const handleEmailChange = (newEmail) => {
    setEmail(newEmail);
    setIsInputEmpty(false);
  };


  const getPricing = () => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        filters: {
        },
      }),
    };


    fetch(baseUrl + 'api/mgmt/pricing/listPricingCms', requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setListPricing(data)// Log the response data to the console

      })
      .catch((error) => {
        console.error('Error fetching pricing:', error);

      });
  };

  useEffect(() => {

    getPricing();
  }, []);



  const handleStatusUpdate = () => {

    setUpdateLoading(true);

    setIndividualPaymentStatuses(prevStatuses => ({
      ...prevStatuses,
      [selectedPayment.id]: selectedStatus, // Use selectedStatus here
    }));

    // Make API call to update the status
    const apiUrl = baseUrl + 'api/mgmt/payments/updatePayment';
    const authToken = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';

    const requestData = {

      id: parseInt(selectedPayment.id),
      org_id: parseInt(selectedPayment.org_id),
      transaction_id: selectedPayment.transaction_id,
      pricing_id: selectedPayment.pricing_id,
      start_date: selectedPayment.start_date,
      end_date: selectedPayment.end_date,
      device_counts: selectedPayment.device_counts,
      env_counts: selectedPayment.env_counts,
      amount: selectedPayment.amount,
      source: "cms",
      active: true,
      pricing_name: selectedPayment.pricing_name,
      transaction_status: selectedStatus, // Use selectedStatus here
    };

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': authToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to update status');
        }
        return response.json();
      })
      .then(data => {
        console.log("data from updateapi", data);
        const selectedPaymentID = selectedPayment.id;
        const updatedPaymentIndex = apiResponse.findIndex(payment => payment.id === selectedPaymentID);
        const updatedPaymentList = [...apiResponse];
        console.log("updatedPaymentIndex", updatedPaymentIndex);
        updatedPaymentList[updatedPaymentIndex].status = selectedStatus;

        setPaymentData(updatedPaymentList);
        setUpdatedPaymentData(updatedPaymentList[updatedPaymentIndex]);
        setIndividualPaymentStatuses(prevStatuses => ({
          ...prevStatuses,
          [selectedPaymentID]: selectedStatus,
        }));

        setUpdateLoading(false);
        fetchPaymentData(data.data.org_id);
        handleCloseModal();
      })
      .catch(error => {
        console.error('Error:', error);
        setUpdateLoading(false);
      });
  };

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    setSelectedStatus(newStatus); // Store the selected status for updating later

  };

  const handleStausUpdate2 = (event) => {
    setNewStatus(event.target.value);
  };

  const deleteConfirmation = (payment) => {
    setDeleteConfirmationOpen(true);
    setSelectedPaymentToDelete(payment);
  };

  //function to delete a payment

  const handleDeletePayment = () => {

    const payment = selectedPaymentToDelete;
    console.log('payment', payment);

    setDeleteConfirmationOpen(false);
    setDeleteLoading(true);

    const apiUrl = baseUrl + 'api/mgmt/payments/deletePaymentCms';
    const authToken = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'; // Replace with your actual auth token

    const requestData = {
      id: payment.id,
      org_id: payment.org_id,
      transaction_id: payment.transaction_id,
    };

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': authToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Delete payment response:', data);

        console.log('Payment entry deleted successfully')
        // Payment entry was deleted successfully, update the table data
        const updatedPaymentList = apiResponse.filter(item => item.id !== payment.id);
        console.log('updatedPaymentList', updatedPaymentList);
        setApiResponse(updatedPaymentList);


        fetchPaymentData(payment.org_id);

        console.log('Delete payment response:', data);
        setDeleteLoading(false);

      })
      .catch(error => {
        console.error('Error deleting payment:', error);
        // Handle error if necessary
        setDeleteLoading(false);
      });
  };


  const renderPaymentStatus = () => {

    if (!paymentStatusData || !paymentStatusData.data || !paymentStatusData.data.org_payment_status || !paymentStatusData.data.org_payment_status.counts) {
      return null;
    }

    const expiryDate = new Date(paymentStatusData.data.org_payment_status.due_date);
    const formattedExpiryDate = expiryDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });


    return (

      <div>
        <Paper maxWidth="sm" style={{ border: '1px solid #ccc', marginLeft: 30, borderRadius: 5, padding: '16px', width: 300 }}>
          <Typography variant='h5' style={{ fontSize: 18, marginBottom: '6px', fontWeight: 'bold' }}>
            Subscription Info
          </Typography>

          <Typography variant='subtitle1' style={{ textAlign: 'left', fontSize: 14 }}>
            Org ID: {paymentStatusData.data.org_payment_status.org_id}
          </Typography>

          <Typography variant='subtitle1' style={{ textAlign: 'left', fontSize: 14 }}>
            Remaining ENV Counts: {paymentStatusData.data.org_payment_status.counts.remaining_env_counts}
          </Typography>

          <Typography variant='subtitle1' style={{ textAlign: 'left', fontSize: 14 }}>
            Remaining Device Counts: {paymentStatusData.data.org_payment_status.counts.remaining_device_counts}
          </Typography>


          <Typography variant='subtitle1' style={{ textAlign: 'left', fontSize: 14 }}>

            Status: {paymentStatusData.data.org_payment_status.status === 'paid' ? (
              //show the status in Uppercase
              <span style={{ textTransform: 'uppercase', color: paymentStatusData.data.org_payment_status.color }}>{paymentStatusData.data.org_payment_status.status}</span>
            ) : (
              <span style={{ color: paymentStatusData.data.org_payment_status.color, textTransform: 'uppercase' }}>{paymentStatusData.data.org_payment_status.status}</span>
            )}
          </Typography>

          <Typography variant='subtitle1' style={{ textAlign: 'left', fontSize: 14 }}>
            Plan Ends: {formattedExpiryDate}
          </Typography>

        </Paper>
      </div>

    );
  };

  return (
    <>
      <Layout>
        <div style={{ textAlign: 'center', margin: 80 }}>

          <Typography variant="h5" style={{ marginTop: 100 }}>
            Check Payment Status
          </Typography>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ marginTop: 60 }}>
              <TextField
                label="Org ID"
                variant="outlined"
                id="orgID"
                type="text"
                value={orgID}
                onChange={(e) => setOrgId(e.target.value.trim())}
                error={isInputEmpty}

                helperText={isInputEmpty ? 'Please enter an orgID' : ''}
                disabled={email || phone}
              />
            </div>
            <div style={{ display: 'flex', flexWrap: 'nowrap', marginTop: 60 }}>
              <Typography variant="subtitle1" style={{ color: '#777', margin: '19px 16px' }}>
                - OR -
              </Typography>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 60 }}>
              <TextField
                label="Email Id"
                value={email}
                onChange={e => setEmail(e.target.value.trim())}
                variant="outlined"
                error={isInputEmpty && !email}
                helperText={isInputEmpty && !email ? 'Please enter Email Id' : ''}
                disabled={orgID || phone}
              />
            </div>

            <div style={{ display: 'flex', flexWrap: 'nowrap', marginTop: 60 }}>
              <Typography variant="subtitle1" style={{ color: '#777', margin: '19px 16px' }}>
                - OR -
              </Typography>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 60 }}>
              <TextField
                label="Phone Number"
                value={phone}
                onChange={e => setPhone(e.target.value.trim())}
                variant="outlined"
                error={isInputEmpty && !phone}
                helperText={isInputEmpty && !phone ? 'Please enter Phone Number' : ''}
                disabled={email || orgID}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'right' }}>
              {paymentStatusData && renderPaymentStatus()}
            </div>

          </div>


          <div style={{ width: 300 }}>
          </div>
          <br></br>
          <Button onClick={handleClick} variant="contained" color="primary">
            Submit
          </Button>
          <Button style={{ marginLeft: 10 }} variant="contained" color="primary" onClick={handleOpen}>
            Add +
          </Button>
        </div>
        <div>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
              <CircularProgress />
            </div>
          ) : (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Org ID
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Transaction ID
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Pricing Name
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Subs. Start Date
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Subs. End Date
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Device Counts
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Env Counts
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Amount
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Transaction Status
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Status
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Edit
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    apiResponse && Array.isArray(apiResponse) && apiResponse.length > 0 ? (


                      apiResponse.map((item) => (
                        < TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          style={{ height: 90, cursor: 'pointer' }}>
                          <TableCell align="center">{item.org_id}</TableCell>
                          <TableCell align="center">{item.transaction_id}</TableCell>
                          <TableCell align="center">{item.pricing_name}</TableCell>
                          <TableCell align="center">{moment(item.start_date).format("LL")}</TableCell>
                          {/* <TableCell align="center"> {new Date(item.end_date).toISOString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).split('T')[0]}</TableCell> */}
                          <TableCell align="center">
                            {item.end_date ? moment.utc(item.end_date).format("LL") : null}
                          </TableCell>
                          < TableCell align="center" > {item.device_counts}</TableCell>
                          <TableCell align="center">{item.env_counts}</TableCell>
                          <TableCell align="center">₹{item.amount}</TableCell>
                          <TableCell align="center">
                            <span
                              style={{
                                color:
                                  item.transaction_status === 'failed'
                                    ? 'red'
                                    : item.transaction_status === 'initiated'
                                      ? 'blue'
                                      : item.transaction_status === 'completed'
                                        ? 'green'
                                        : 'inherit', // Default text color
                              }}
                            >
                              {item.transaction_status}
                            </span>
                          </TableCell>
                          <TableCell align="center">
                            <span style={{
                              color:
                                item.active ? 'green' : 'red'
                            }}>
                              {item.active ? "Active" : "Inactive"}
                            </span>
                          </TableCell>

                          <TableCell align="center">

                            <>
                              <Button variant="outlined" color="primary" onClick={() => handleOpenModal(item)} style={{ marginRight: 5 }}>
                                Update
                              </Button>
                              {
                                item.transaction_status == "completed" ? <Button variant="outlined" color="secondary" disabled onClick={() => handleDeletePayment(item)}>
                                  Delete
                                </Button>

                                  : <Button variant="outlined" color="secondary" onClick={() => deleteConfirmation(item)}>
                                    Delete
                                  </Button>
                              }
                            </>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (


                      <TableRow>
                        <TableCell align="center" colSpan={7}>
                          {apiResponse && apiResponse.data === null ? (
                            <Typography variant="subtitle1">No data available</Typography>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    )}
                </TableBody>
              </Table>
            </TableContainer>

          )}
        </div >
        <CustomModal open={open} onClose={handleClose} onOrgIdChange={handleOrgIdChange} paymentStatusData={paymentStatusData}
          onEmailChange={handleEmailChange} handleClick={handleClick} onSubmit={handleSubmit} pricing={listPricing} />


        <Dialog open={modalOpen} onClose={handleCloseModal} disableEnforceFocus>
          <DialogTitle>Payment Details</DialogTitle>
          <DialogContent sx={{ width: '800px' }}>
            {selectedPayment && (
              <Grid container spacing={3}>

                <Grid item xs={6}>
                  <Typography>Org ID: {selectedPayment.org_id}</Typography>
                  <Typography>Transaction ID: {selectedPayment.transaction_id}</Typography>
                  <Typography variant="body1" >Pricing ID: {pricingId}</Typography>

                </Grid>
                <Grid item xs={6}>

                  <Typography variant="body1" >Start Date: {startDate}</Typography>
                  <Typography variant="body1">End Date: {endDate}</Typography>

                </Grid>

                <Grid item xs={6} spacing={5}>
                  <TextField
                    label="Device Counts"
                    fullWidth
                    variant="outlined"
                    style={{ marginBottom: 10 }}
                    value={deviceCounts}
                    disabled={true}
                    onChange={(e) => setDeviceCounts(e.target.value.trim())}
                  />
                  <TextField
                    label="Env Counts"
                    fullWidth
                    variant="outlined"
                    style={{ marginBottom: 10 }}
                    value={envCounts}
                    disabled={true}
                    onChange={(e) => setEnvCounts(e.target.value.trim())}
                  />
                  <TextField
                    label="Amount"
                    fullWidth
                    variant="outlined"
                    value={amount}
                    disabled={true}
                    onChange={(e) => setAmount(e.target.value.trim())}

                  />
                </Grid>

                <Grid item xs={6} spacing={5}>
                 
                  <FormControl style={{ marginTop: 10, width: 250, textAlign: 'center' }}>
                    <InputLabel>Payment Status</InputLabel>
                    <Select value={selectedStatus} style={{ marginTop: 20 }} onChange={handleStatusChange}>
                      <MenuItem value="initiated" >Initiated</MenuItem>
                      <MenuItem value="completed">Completed</MenuItem>
                      <MenuItem value="refund" >Refund</MenuItem>
                      <MenuItem value="failed">Failed</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} variant="contained" color="secondary">
              Close
            </Button>
            <Button variant="contained" onClick={handleStatusUpdate} color="primary">
              {updateLoading ? <CircularProgress size={24} color="inherit" /> : 'Update'}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={deleteConfirmationOpen} onClose={() => setDeleteConfirmationOpen(false)} disableEnforceFocus>
          <DialogTitle>Delete Payment</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this payment?
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={() => setDeleteConfirmationOpen(false)} color="primary">
              Cancel
            </Button>
            <Button variant="outlined" onClick={handleDeletePayment} color="secondary" disabled={deleteLoading}>
              {console.log(deleteLoading)}
              {deleteLoading ? <CircularProgress size={24} /> : 'Delete'}
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={apiError !== null} // Show Snackbar when there's an error
          autoHideDuration={5000}
          onClose={() => setApiError(null)} // Close Snackbar on close
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          message={apiError}
          style={{ marginTop: 60 }}
        >
          {/* Step 4: Display the error message in the Snackbar */}
          {/* <Alert severity="error" onClose={() => setApiError(null)}>
            {apiError}
          </Alert> */}
        </Snackbar>
      </Layout >
    </>

  );
};